import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';

export const DataLoadIndicator = ({ dataLoadInfo }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { visibleLayerCount, loadStatus } = dataLoadInfo;

  if (visibleLayerCount === 0 || loadStatus.level === 'normal') return null;

  const getStatusColor = () => {
    switch (loadStatus.level) {
      case 'high':
        return 'bg-red-500';
      case 'medium':
        return 'bg-orange-500';
      default:
        return 'bg-green-500';
    }
  };

  const getTextColor = () => {
    switch (loadStatus.level) {
      case 'high':
        return 'text-red-700';
      case 'medium':
        return 'text-orange-700';
      default:
        return 'text-green-700';
    }
  };

  const getBorderColor = () => {
    switch (loadStatus.level) {
      case 'high':
        return 'border-red-500';
      case 'medium':
        return 'border-orange-500';
      default:
        return 'border-green-500';
    }
  };

  return (
    <div
      className={clsx(
        'absolute top-16 right-2 bg-white rounded-lg shadow-lg border z-10 w-fit flex flex-col items-center',
        getBorderColor(),
      )}
    >
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-2 py-1 flex items-center justify-between gap-2 hover:bg-gray-50 rounded-t-lg"
      >
        <div className="flex items-center gap-2">
          <div className={clsx('w-3 h-3 rounded-full', getStatusColor())} />
          <span className="text-sm font-medium">Data Load: {loadStatus.level}</span>

        </div>
        {loadStatus.level !== 'normal' && (
          <ExclamationTriangleIcon className={clsx('w-5 h-5', getTextColor())} />
        )}
        {loadStatus.level === 'normal' && (
          <InformationCircleIcon className="w-5 h-5 text-gray-500" />
        )}
      </button>

      {isExpanded && (
        <div className="px-1 py-4 border-t border-gray-200 max-w-44">
          <div>
            <p className={clsx('text-xs font-medium mb-1 text-center m-0', getTextColor())}>
              {loadStatus.message}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
